exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".banka-hareketleri-report-table[data-v-69d6f760],.banka-hareketleri-report-table>*[data-v-69d6f760]{width:100%}.banka-hareketleri-cell[data-v-69d6f760]{width:100%;min-height:24px;cursor:pointer}", ""]);

// exports
